module.exports = __webpack_public_path__ + "img/中国地质大学.79db44a2.png";